export { currencyFormat }

function currencyFormat(fullNumber) {
	if (typeof fullNumber === 'number') {
		fullNumber = String(fullNumber).replaceAll('.', ',')
	}
	let splitNumber = fullNumber.replaceAll('.', '').split(',')
	let intPart = Array.from(splitNumber[0])
	let count = 0
	for (let i = intPart.length - 1; i > -1; i--) {
		count++
		if (count === 3) {
			if (i === 0) continue
			intPart.splice(i, 0, '.')
			count = 0
		}
	}
	splitNumber[0] = intPart.join('').trim()

	if (isNaN(splitNumber[1])) splitNumber[1] = 0
	splitNumber[1] = (splitNumber[1] + '00').substring(-2, 2)
	return splitNumber.join(',')
}
